/*
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2025-08-08 09:18:08 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2025-08-08 09:39:29 +0800
 * @FilePath     : /izt_web/src/utils/isPCDevice.js
 * @Description  : 验证方法
 */

// 是否手机号
export const isPCDevice = () => {
  const ua = navigator.userAgent;

  const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|iPad|Windows Phone/i.test(ua);
  const isWeChat = /MicroMessenger/i.test(ua);

  // 非移动设备，且不是微信浏览器，即可认为是 PC 端
  return !isMobile && !isWeChat;
};